import React, { ReactElement } from 'react';
import { Button, Grid, Row, Col } from 'rsuite';
import { Text } from 'rsuite';
import IconIndicator from '../../../user-feedback/IconIndicator';
import Notice from '../../../user-feedback/Notice';

interface CheckProps {
  loading?: boolean;
  onPay?: () => void;
  error?: string;
}

const Check = ({ loading, onPay, error }: CheckProps): ReactElement => {
  return (
    <Grid
      fluid
      data-testid="check-component"
    >
      <Row className="mb-16">
        <Col xs={24}>
          <Text>
            Please click the button below to confirm that you wish to pay by
            check.
          </Text>
        </Col>
      </Row>
      {error && (
        <Row className="mb-16">
          <Col xs={24}>
            <Notice message={error} />
          </Col>
        </Row>
      )}
      {loading && (
        <Row className="mb-16">
          <Col xs={24}>
            <IconIndicator />
          </Col>
        </Row>
      )}
      <Row className="pt-16">
        <Col xs={24}>
          <Button
            className="btn-primary full-width"
            disabled={loading}
            onClick={onPay}
          >
            Select Check as your payment method
          </Button>
        </Col>
      </Row>
    </Grid>
  );
};

export default Check;
